import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/salesOrderProfitLoss/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  const newRecord = record.map((line) =>
    transformFields(line, FIELDS_TO_TRANSFORM)
  );
  return newRecord;
}
